import React, { useState } from "react";
import axios from "axios";
import { Box, Typography, IconButton, Tooltip,Dialog, DialogTitle, DialogContent, DialogActions, TextField, Button } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import PersonAddAlt1Icon from "@mui/icons-material/PersonAddAlt1";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";

import BoutonModifyGroupName from "./BoutonModifyGroupName.js";
import { BoutonSave, BoutonCancel } from "./BoutonSaveCancel.js";

import { useGroupe } from "../context/GroupeContext.js";
import { useLanguage } from "../context/LanguageContext.js";

import { logDev } from "../utils/logger.js";

import EmojiPicker from "../components/EmojiPicker.js";

const HeaderGroupe = ({
  nomGroupeConnecte,
  emoji,
  setNouvelEmoji,
  nouvelEmoji,
  couleur,
  nouvelleCouleur,
  setNouvelleCouleur,
  isAdmin,
  isMobile,
  bottomNavHeight,
  headerHeight,
  editionNomActive,
  setEditionNomActive,
  nouveauNomGroupe,
  setNouveauNomGroupe,
  groupeActif,
  setGroupeActif,
  reloadContacts,
  setContacts,  
  emailConnect,
  setNomGroupeConnecte,
  setOpenConfirm,
  setSnackbar,
  sondageVerrouille,
  t
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const { reloadGroupeActif } = useGroupe();
  const [nomInvalide, setNomInvalide] = useState(false);
  const { lang } = useLanguage();
  const [tempCouleur, setTempCouleur] = useState(nouvelleCouleur || "#71685e");
  const [whatsappOuvert, setWhatsappOuvert] = useState(false);
  const [lienWhatsApp, setLienWhatsApp] = useState(groupeActif?.lienWhatsApp || "");

  const estGroupeEssai =
    groupeActif?.abonnementActif === false &&
    groupeActif?.quota?.groupesMax === 1 &&
    groupeActif?.quota?.contactsMax <= 20;
    
    const verifierNomDisponible = async (nom) => {
    try {
    const res = await axios.get(`${process.env.REACT_APP_API}/groupes/check`, {
      params: {
        nom: nom.trim(),
        excludeId: groupeActif._id
      }
    });

    return !res.data.exists;
    } catch (err) {
      logDev("❌ Erreur vérification nom", { message: err.message });
      return false;
      }
    };

    if (editionNomActive && sondageVerrouille ) {

      return (

        <Typography variant="body2" sx={{ textAlign: "center", mt: 2 }}>
          🔒 Le sondage est clôturé — modification du groupe désactivée.
          </Typography>
      );
    }

    return !editionNomActive ? (

      <Box sx={{ width: "100%", mb: 1 }}>

        {/* NOM + BOUTON MODIFIER */}
        <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: 1,
          mb: 1,
          flexWrap: { xs: "wrap", sm: "nowrap" }   // 🔥 mobile = wrap, desktop = une ligne
        }}
        >
          
          <Typography
          variant="h6"
          sx={{
            fontWeight: "bold",
            textAlign: "center",
            color: tempCouleur || nouvelleCouleur || groupeActif?.couleur || "#71685e",
            display: "flex",
            alignItems: "center",
            gap: 1
          }}
        >
          {nouvelEmoji || emoji || ""} {nomGroupeConnecte}
          </Typography>
          
          {estGroupeEssai && (
            <Box         
            sx={{
              px: 2,
              py: 1,
              backgroundColor: "#f0f4ff",
              borderLeft: `6px solid ${groupeActif?.couleur || "#1976d2"}`,
              borderRadius: 1,
              textAlign: "center",
              mt: 1
            }}
          >

            <Typography variant="body2">
              {groupeActif?.emoji || "🎁"} <strong>Groupe d’essai actif</strong> – vous pouvez le prolonger gratuitement ou choisir un abonnement.
              </Typography>

            <Typography variant="body2" sx={{ mt: 0.5 }}>
              Quota : {groupeActif?.quota?.groupesMax} groupe{groupeActif?.quota?.groupesMax > 1 ? "s" : ""} / {groupeActif?.quota?.contactsMax} contact{groupeActif?.quota?.contactsMax > 1 ? "s" : ""}
              </Typography>
          </Box>
        )}

        {isAdmin && !sondageVerrouille && (
          <BoutonModifyGroupName         
          label={t("ModifyGroupName")}
          onClick={() => {
            setNouveauNomGroupe(nomGroupeConnecte);
            setEditionNomActive(true);
            setNouvelleCouleur(groupeActif?.couleur || "#71685e");
          }}
        />
      )}
      </Box>

      {/* ICÔNES EN DESSOUS, SUR UNE SEULE LIGNE, SANS SCROLL */}
      {isAdmin && (
        <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" }, 
          justifyContent: "center",
          alignItems: "center",
          gap: 2,
          mt: 2
        }}
      >

        {isAdmin && (
          <Tooltip title={t("LinkWhatsAppGroup")} arrow>
            <IconButton
              color="success"
              sx={{
              p: 1,
              backgroundColor: "transparent",
              "&:hover": { backgroundColor: "transparent" },
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
            }}
            onClick={() => {
              setLienWhatsApp(groupeActif?.lienWhatsApp || "");
              setWhatsappOuvert(true);
            }}
          >

            <Typography sx={{ fontSize: "1.8rem", lineHeight: 1 }}>
              🟢

              </Typography>


              <Typography
              variant="caption"
              sx={{ fontSize: "0.7rem", mt: 0.3, opacity: 0.8 }}
              >
                {t("LinkWhatsAppGroup")}
                </Typography>

            </IconButton>
          </Tooltip>
        )}

        {groupeActif?.lienWhatsApp && (

          <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            mt: 2
          }}
        >

          <Button
            variant="text"
            color="success"
            component="a"
            href={groupeActif.lienWhatsApp}
            target="_blank"
            rel="noopener noreferrer"
            startIcon={<OpenInNewIcon 
              sx={{
                fontSize: isMobile ? "16px !important" : "18px !important"
              }}
            />
          }
          sx={{
            fontSize: isMobile ? "0.7rem" : "0.8rem",
            minWidth: 0,
            padding: isMobile ? "2px 4px" : "3px 6px",
            textTransform: "none",
          }}
        >
          {t("OpenWhatsApp")}
        </Button>
      </Box>
    )}

    {/* EXTEND : uniquement si le sondage n'Est pas verrouillé*/}
    {!sondageVerrouille && (
      <Tooltip title={t("ExtendOrAddAGroup")} arrow>
        <IconButton
          color="primary"
          sx={{
            p: 1,
            backgroundColor: "transparent",         
            "&:hover": { backgroundColor: "transparent" },
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}

          onClick={() => {
            const url = `/paiement/${groupeActif._id}?nom=${encodeURIComponent(groupeActif.nom)}`;
            window.location.href = url;
          }}
          >

            <PersonAddAlt1Icon sx={{ fontSize: { xs: "1.8rem", sm: "2rem" } }} />

          <Typography variant="caption" sx={{ fontSize: "0.7rem", mt: 0.3, opacity: 0.8 }}>
            {t("ExtendContacts")}
          </Typography>

        </IconButton>
      </Tooltip>
      )}

      {/* ADD CREATOR */}
      {isAdmin && !sondageVerrouille && ( 
      <Tooltip title={t("AddCreatorToContactsList")}  arrow>
        <IconButton
          color="primary"
          sx={{
            p: 1,
            backgroundColor: "transparent",
            "&:hover": { backgroundColor: "transparent" },
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
          onClick={async () => {
            try {
              await axios.post(`${process.env.REACT_APP_API}/contacts`, {
              groupe: groupeActif._id,
              nom: "Créateur",
              mail: groupeActif.createur,
              telephone: groupeActif.telephone
            });

            setSnackbar({
              open: true,
              message: t("CreatorAdded"),
              severity: "success"
            });

          // 🔄 recharge immédiatement les contacts
          const updatedContacts = await axios.get(
            `${process.env.REACT_APP_API}/contacts?groupeId=${groupeActif._id}`
          );

          setContacts(updatedContacts.data);
          window.location.reload();
          // 🔄 

          } catch (err) {
          
          setSnackbar({
            open: true,
            message: t("CreatorAddFailed"),
            severity: "error"
          });
        }
      }}
    >
    <PersonAddAlt1Icon sx={{ fontSize: { xs: "1.8rem", sm: "2rem" } }} />

      <Typography variant="caption" sx={{ fontSize: "0.7rem", mt: 0.3, opacity: 0.8 }}>
        {t("AddCreator")}
      </Typography>
    </IconButton>
  </Tooltip>
  )}

  {!sondageVerrouille && (
  <>

  {/* DELETE */}
        <Tooltip title={t("DeleteGroup")} arrow>
          <IconButton
            color="error"
              sx={{
                p: 1,
                backgroundColor: "transparent",
                "&:hover": { backgroundColor: "transparent" },
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                "& .MuiSvgIcon-root": {
                  fontSize: "28px !important",
                }
              }}
              onClick={() => setOpenConfirm(true)}
            >
              <DeleteIcon sx={{ fontSize: { xs: 26, sm: 30 } }} />

              {/* Texte visible uniquement sur mobile */}
              <Typography
                variant="caption"
                sx={{
                  display: { xs: "block", sm: "none" },
                  mt: 0.3,
                  opacity: 0.8
                }}
              >
              {t("DeleteGroup")}
              </Typography>
            </IconButton>
          </Tooltip>
          </>
          )}
  
         
    </Box>
    

      )}

      {logDev("🔎 HeaderGroupe t", {
        type: typeof t,
        t
      })}

      <Dialog
      open={whatsappOuvert}
      onClose={() => setWhatsappOuvert(false)}
      fullWidth
      maxWidth="sm"
      >

        <DialogTitle>
          {t("LinkWhatsAppGroup")}
        </DialogTitle>

        <DialogContent>

          <Typography variant="body2" sx={{ mb: 2 }}>
            {t("EnterWhatsAppGroupLink")}
          </Typography>

          <TextField
            fullWidth
            label={t("WhatsAppGroupLink")}
            value={lienWhatsApp}
            onChange={(e) => setLienWhatsApp(e.target.value)}
            margin="normal"
            placeholder="https://chat.whatsapp.com/..."
          />

          <Typography
            variant="body2"
            sx={{
              mt: 2,
              p: 1.5,
              backgroundColor: "#f5f5f5",
              borderRadius: 1
            }}
          >
            {t("WhatsAppGroupLinkIndication")}
          </Typography>
        </DialogContent>

        <DialogActions>

          <Button onClick={() => setWhatsappOuvert(false)}>
            {t("Cancel")}
          </Button>

          <Button
            variant="contained"
            onClick={async () => {
              if (!lienWhatsApp.trim()) {
                setSnackbar({
                  open: true,
                  message: "Veuillez renseigner le lien WhatsApp.",
                  severity: "error"
                });
                return;
              }

              try {
                await axios.put(
                  `${process.env.REACT_APP_API}/groupes/${groupeActif._id}`,
                  {
                    nom: groupeActif.nom,
                    emoji: groupeActif.emoji,
                    couleur: groupeActif.couleur,
                    lienWhatsApp: lienWhatsApp.trim(),
                    utilisateurId: emailConnect
                  }
                );

                await reloadGroupeActif();

                setWhatsappOuvert(false);

                setSnackbar({
                  open: true,
                  message: "Groupe WhatsApp lié avec succès.",
                  severity: "success"
                });
              } catch (err) {
                logDev(
                  "❌ Erreur liaison groupe WhatsApp",
                  {
                    message: err.message,
                    stack: err.stack
                  }
                );

                setSnackbar({
                  open: true,
                  message: "Impossible de lier le groupe WhatsApp.",
                  severity: "error"
                });
              }
            }}
          >
            {t("Save")}
          </Button>
        </DialogActions>
      </Dialog>


    </Box>
  ) : sondageVerrouille ? (
    <Typography variant="body2" sx={{ textAlign: "center", mt: 2 }}>
     🔒 t("GroupModificationDesactivated")
    </Typography>
  ) : (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 2,
        mt: 2
      }}
    >
      <Typography sx={{ fontSize: "2rem", mb: 1 }}>
        {nouvelEmoji || "🧩"}
      </Typography>

      <EmojiPicker
        onSelect={(emoji) => {
          if (!sondageVerrouille) setNouvelEmoji(emoji);
        }}
      />

      <Typography
        sx={{
          fontSize: "1.2rem",
          fontWeight: "bold",
          color: nouvelleCouleur,
          backgroundColor: "#fff",
          padding: "6px 12px",
          borderRadius: "6px",
          border: `2px solid ${nouvelleCouleur}`,
          boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
          textAlign: "center",
          display: "flex",
          alignItems: "center",
          gap: 1
        }}
      >
        {nouvelEmoji || "🧩"} {nouveauNomGroupe || t("GroupName")}
      </Typography>

      <input
        type="text"
        disabled={sondageVerrouille}
        value={nouveauNomGroupe}
        onChange={(e) => {setNouveauNomGroupe(e.target.value);
        setNomInvalide(false);
        }}
        
        style={{
          width: isMobile ? "120px" : "200px",
          padding: "6px 8px",
          borderRadius: "4px",
          border: nomInvalide ? "2px solid red" : "1px solid #ccc",
          fontSize: "0.9rem"
        }}
      />

      <input
        type="color"
        disabled={sondageVerrouille}
        value={tempCouleur}
        onChange={(e) => setTempCouleur(e.target.value)}
        style={{
          width: "40px",
          height: "40px",
          border: "none",
          cursor: "pointer"
        }}
      />

        <BoutonSave
          disabled={sondageVerrouille}
          onClick={async () => {
            if (sondageVerrouille) return;

            const nomModifie = nouveauNomGroupe.trim() !== groupeActif.nom.trim();

        if (nomModifie) {
          const nomDisponible = await verifierNomDisponible(nouveauNomGroupe);
          if (!nomDisponible) {
            setNomInvalide(true);
            setSnackbar({
              open: true,
              message: t("GroupNameAlreadyUsed"),  
              severity: "error"
          });
          return;
        }
      }

      setNomInvalide(false);

      try {
        await axios.put(`${process.env.REACT_APP_API}/groupes/${groupeActif._id}`, {
          nom: nouveauNomGroupe,
          emoji: nouvelEmoji,
          couleur: tempCouleur,
          lienWhatsApp: groupeActif?.lienWhatsApp || "",
          utilisateurId: emailConnect
        });

        // mise à jour immédiate en local
        setNomGroupeConnecte(nouveauNomGroupe);
        setNouvelEmoji(nouvelEmoji);
        setNouvelleCouleur(tempCouleur);

        // 🔄 Au lieu de faire un axios.get local, on recharge via le contexte
        await reloadGroupeActif();
        /*const updated = await axios.get(`${process.env.REACT_APP_API}/groupes/${groupeActif._id}`);*/

        // puis recharge globale pour synchroniser
        setEditionNomActive(false);

      setSnackbar({
        open: true,
        message: t("GroupUpdated"),
        severity: "success"
      });
    } catch (err) {
      logDev("❌ Erreur mise à jour du nom du groupe", { message: err.message, stack: err.stack });
      
      setSnackbar({
        open: true,
        message: t("GroupNameModificationImpossible"),  
        severity: "error"
      });
    }
  }}
/>

      <BoutonCancel onClick={() => setEditionNomActive(false)} />
    </Box>
  );
};

export default HeaderGroupe;